export const MOBILE_TEXT_SIZE = 60;
export const DESKTOP_TEXT_SIZE = 170;

export const HIDE_BUTTON = 'Скрыть';
export const DETAILS_BUTTON = ' ... Подробнее';
